import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bookingCom = defineConnector({
  identifier: "bookingCom",
  name: "Booking.com",
  tagLine: "Travel accommodation booking",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*-xml\\.booking\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Find your Booking.com API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Contact the [Booking.com Connectivity Partner Program](https://partner.booking.com/) to obtain API credentials. You will need a username and password for basic authentication.",
        },
      ],
    },
    {
      title: "Connect your Booking.com account",
      items: [
        {
          kind: "markdown",
          content:
            "Enter your Booking.com instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Environment Type",
          placeholder: "secure-supply|supply",
          required: true,
          target: { kind: "configuration", field: "environmentType" },
          helperText:
            "The environment type for your various requests (e.g. https://secure-supply|supply-xml.booking.com)",
        },
        {
          kind: "input",
          label: "Machine Account Username",
          required: true,
          target: { kind: "secrets", field: "username" },
          helperText: "The username for your Booking.com machine account",
        },
        {
          kind: "input",
          label: "Machine Account Password",
          required: true,
          target: { kind: "secrets", field: "password" },
          helperText: "The password for your Booking.com machine account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.environmentType}-xml.booking.com/`,
  },
  publicEnvVars: ({ environmentType }) => ({
    BOOKING_COM_ENVIRONMENT_TYPE: environmentType || "",
  }),
});
